import styled from 'styled-components'

export const Wrap = styled('div')`
  position: fixed;
  width: 100%;
  height: 100vh;
  z-index: 9999;
  background: rgba(255, 255, 255, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
`
